module.exports = __webpack_public_path__ + "static/media/banner2.94c0c402.svg";